'use strict';

var variables = require('./variables-1eb6495a.js');
var colorManipulator = require('./colorManipulator-abc93889.js');

const light = {
    root: {
        height: "32px",
        lineHeight: "16px",
        fontSize: 14,
        borderRadius: variables.SIZES.BORDER_RADIUS,
    },
    // @ts-ignore TODO fix this ignore
    text: {
        padding: "8px 16px",
        "&:active": {
            backgroundColor: variables.COLORS.GREYSCALE_0_10,
        },
        "&$focusVisible": {
            boxShadow: `0 0 0 2px ${variables.COLORS.MISC_FOCUS_BORDER}`,
        },
    },
    outlined: {
        padding: "7px 16px",
        borderColor: variables.COLORS.GREYSCALE_0_15,
        backgroundColor: variables.COLORS.GREYSCALE_100_60,
        "&:active": {
            backgroundColor: variables.COLORS.GREYSCALE_0_10,
        },
        "&$focusVisible": {
            borderColor: variables.COLORS.MISC_FOCUS_BORDER,
            boxShadow: `0 0 0 1px ${variables.COLORS.MISC_FOCUS_BORDER}`,
        },
    },
    contained: {
        padding: "8px 16px",
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none",
        },
        "&:active": {
            boxShadow: "none",
        },
    },
    containedPrimary: {
        "&:hover": {
            backgroundColor: variables.COLORS.GREEN_PALE,
        },
        "&:active": {
            backgroundColor: variables.COLORS.GREEN_DARK,
        },
        "&$focusVisible": {
            borderColor: variables.COLORS.GREEN_PALE,
            boxShadow: `0 0 0 3px ${colorManipulator.alpha(variables.COLORS.GREEN_PALE, 0.5)}`,
        },
    },
    containedSecondary: {
        "&:hover": {
            backgroundColor: variables.COLORS.BLUE_PALE,
        },
        "&:active": {
            backgroundColor: variables.COLORS.BLUE_DARK,
        },
        "&$focusVisible": {
            borderColor: variables.COLORS.BLUE_PALE,
            boxShadow: `0 0 0 3px ${colorManipulator.alpha(variables.COLORS.BLUE_PALE, 0.5)}`,
        },
    },
    sizeSmall: {
        fontSize: 12,
        height: "24px",
    },
    sizeLarge: {
        fontSize: 16,
        height: "40px",
        lineHeight: "20px",
    },
    textSizeSmall: {
        padding: "4px 11px",
    },
    textSizeLarge: {
        padding: "10px 19px",
    },
    outlinedSizeSmall: {
        padding: "3px 11px",
    },
    outlinedSizeLarge: {
        padding: "9px 19px",
    },
    containedSizeSmall: {
        padding: "4px 11px",
    },
    containedSizeLarge: {
        padding: "10px 19px",
    },
};

var MuiButtonGroup = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiButtonGroup = MuiButtonGroup;
exports.light = light;
